import React from 'react';
import { Section } from '../Section';
import { FadeUp } from '../FadeUp';
import { OrderBox } from '../OrderBox';
export function Close() {
  return <Section data-id="element-97" data-mp="3w07xe1ud167l">
      <FadeUp data-id="element-98" data-mp="3w0rexhg3lsl3">
        <h2 className="text-center text-[24px] font-extrabold" data-id="element-99" data-mp="3i7rxvb0o3qbf">
          Tomorrow morning can look <span className="text-gain" data-id="element-100" data-mp="3n6mgocymxevj">completely different</span>. It
          starts with one printed page.
        </h2>

        <div className="mt-8" data-id="element-101" data-mp="eq9ubfrxh5gt">
          <OrderBox data-id="element-102" data-mp="erb3fepdvhvw" />
        </div>

        <p className="mt-4 text-center text-[13px] text-ink/55" data-id="element-103" data-mp="eoyq5euklvp6">
          30-day money-back guarantee · 12 bonuses included · Lifetime access
        </p>
      </FadeUp>
    </Section>;
}